import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";

const VideoList = () => {

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/videos`);
        setVideos(res.data.videos);
      } catch (err) {
        console.error("Failed to fetch videos:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  if (loading) return <p>Loading videos...</p>;


  return (
    <div>
      {videos.map(v => (
        <div key={v._id}>
          <video controls width="400" src={v.url}></video>
          <p>{v.title} - {v.publisher}</p>
        </div>
      ))}
    </div>
  );
};

export default VideoList;
